import { gql } from '@apollo/client';
import { getProductFragment, queryRequiresZipCode } from '../product/getProductQuery';
import { spreadGroupedDomains } from '../../react/util';

const getCollectionDetailQuery = ({ productDomains: initialProductDomains = [] }) => {

  const params = ['$collectionId: String!', '$storeId: String'];
  let productString = '';
  let productFragments = '';
  if (initialProductDomains?.length) {
    const productDomains = spreadGroupedDomains({ domains: initialProductDomains });
    if (queryRequiresZipCode({ domains: productDomains })) {
      params.push('$zipCode: String');
    }
    const fragments = getProductFragment({ domains: productDomains });
    productString = `products {
        ${fragments.queryUnwrapped}
      }`;
    productFragments = fragments.fragments;

  }

  const MainQuery = `
    fragment CollectionQueryFragment on CollectionResponse {
      metadata {
        productCount {
          allProducts
          inStore
        }
        canonicalUrl
        collectionDescription
        baseUrl
        brandName
        storeId
        name
        type
        imageId
        roomType
        startIndex
        pageSize
      }
      ${productString}
      #promotion @todo
      media {
        images {
          url
          sizes
          type
          subType
        }
      }
      taxonomy {
        brandLinkUrl
        breadCrumbs {
          label
          url
          deselectUrl
          dimensionName
        }
        hasVisuallySimilar
      }
      details {
      description
      descriptiveAttributes {
          ...DescriptiveAttributeFragment
      }
      highlights
      #infoAndGuides @todo
      #installation @todo
      }
      descriptors {
          ...DescriptorFragment
      }
      sizeAndFitDetail {
        collectionName
        attributeGroups {
          attributes {
            attributeName
            dimensions
            __typename
          }
          dimensionLabel
          productType
          __typename
        }
        __typename
      }
      __typename
    }

    fragment DescriptorFragment on Descriptor {
        description
        descriptiveAttributes {
            ...DescriptiveAttributeFragment
        }
        heading
    }

    fragment DescriptiveAttributeFragment on DescriptiveAttribute {
        bulleted
        name
        sequence
        value
    }
  `;
  const CollectDetailQuery = `
    query CollectionDetailQuery(${params.join(', ')}) {
      collection(collectionId: $collectionId, storeId: $storeId){
        ...CollectionQueryFragment
      }

      __typename
    }
    ${productFragments}
    ${MainQuery}
  `;
  return gql(CollectDetailQuery);
};
export default getCollectionDetailQuery;
